import algoliasearch from "algoliasearch";
import globals from "/utils/globals";
import getLocale from "/utils/locale";

let client;
let index;
let locale;

export default (query, supportedLanguages) => {
  if (!globals.algolia) {
    return Promise.reject("Search not configured.");
  }

  client =  client || algoliasearch(globals.algolia.appId, globals.algolia.apiKey);
  index = index || client.initIndex(globals.algolia.indexName);
  locale = locale || getLocale();

  const trimmed = query.trim().toLowerCase();
  if (trimmed.length <= 2 || trimmed === "the") {
    return Promise.resolve();
  }
  const filters = [
    `publishedAt < ${Math.floor(Date.now() / 1000)}`,
    `(${supportedLanguages.map(a => `language:${a}`).join(" OR ")})`
  ];
  return index.search(query, {
    attributesToRetrieve: ["title", "author", "slug", "language", "bundle"],
    hitsPerPage: 10,
    attributesToHighlight: ["title", "author"],
    filters: filters.join(" AND ")
  })
    .then(res => {
      const books = {};
      res.hits.forEach(result => {
        const key = result.bundle || `com.blinkist.books.${result.slug}`;
        const savedBook = books[key];
        if (savedBook && result.language === savedBook.language) {
          return;
        }
        books[key] = {
          externalId: result.objectID,
          title: result._highlightResult.title.value,
          author: result._highlightResult.author.value,
          url: `/${locale}/books/${result.slug}`
        };
      });
      return Object.values(books);
    });
};
